<template>

    <v-tabs
        v-if="loaded"
        show-arrows
        grow
        class="elevation-2 folyamatsav"
        color="navbarTextColor"
        ref="tab"
    >

        <v-tabs-slider color="navbarActiveColor" />

        <v-tab v-for="(page, index) in pages"
            :to="getPage(page)"
            :key="pages.indexOf(page)"
            @click="setPage(pages.indexOf(page))"
            :disabled="!available(index)
                || $store.getters.isLoading
                || getRecalculationInProgress
                || getSendDijtajekoztatoInProgress"
            style="color: var(--v-navbarTextColor-base) !important;"
            v-html="page.title"
        >

        </v-tab>

    </v-tabs>

</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'BnTabs',
    props: ['pages', 'color'],
    computed: {
        ...mapGetters([
            'getRecalculationInProgress',
            'getSendDijtajekoztatoInProgress',
        ]),
        loaded() {
            return !this.$store.getters.isLoading;
        },
    },
    methods: {
        getPage(page) {
            if (this.$store.getters.tid != null) {
                return { path: `${page.route}/${this.$store.getters.id}/${this.$store.getters.tid}` };
            }
            return { path: page.route };
        },
        available(index) {
            return this.$store.getters.getAvailablePages[index]
                && !(index === 1 && this.$store.getters.tarifaData.calculationsCount === 0);
        },
        setPage(index) {
            if (this.available(index)) {
                this.$store.commit('setCurrentPage', index);
            }
        },
    },
};
</script>

<style scoped>
    .v-tab--active {
        background-color: #eeeeee;
        font-weight: bold;
    }
</style>

<style>
    .v-slide-group__next, .v-slide-group__prev {
        min-width: 24px !important;
    }
</style>
